import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import Image from '@domain/image';
import Layout from '@domain/layout';
import { useVismaConfiguration } from '@services/visitor-management';

import ErrorIcon from '../../assets/error.svg';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  min-height: 80vh;
  padding: 2rem 0;
  & > img {
    width: 70px;
  }
  @media only screen and (max-width: 1200px) {
    & > img {
      width: 56px;
    }
  }
`;

const Title = styled.h3`
  font-size: 21px;
  font-weight: 600;
  color: ${({ theme }) => theme.text};
  margin: 1em 0;
  text-align: center;

  @media only screen and (max-width: 1200px) {
    margin: 16px 20px;
    font-size: 13px;
  }
`;

const Description = styled.p`
  padding: 0 4em;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.textSecondary};
  text-align: justify;

  @media only screen and (max-width: 1200px) {
    padding: 0 4em;
    margin: 16px 20px;
    font-size: 11px;
  }

  @media only screen and (max-width: 576px) {
    padding: 0;
  }
`;

function LogoutSuccessfulFeature() {
  const intl = useIntl();
  const { configuration } = useVismaConfiguration();
  const infoData = configuration?.infoData;

  return (
    <Layout
      rightPanel={
        <Image
          id={infoData?.featured_image?.id as string}
          alt="logout-banner"
          style={{ height: '100%', width: '100%', objectFit: 'contain' }}
        />
      }
    >
      <Container>
        <img src={ErrorIcon} alt="logout-successful" />
        <Title>{intl.formatMessage({ id: 'LOGOUT_SUCCESSFUL_TITLE' })}</Title>
        <Description>
          {intl.formatMessage({ id: 'LOGOUT_SUCCESSFUL_DESC' })}
        </Description>
      </Container>
    </Layout>
  );
}

export default LogoutSuccessfulFeature;
